import { QueryClient } from '@tanstack/react-query';
import { savingsGoalsGetListQueryKey } from '@unistocks/proxy/axios-client/SavingsGoalsQuery';

export const invalidateSavingsGoalQueryById = (queryClient: QueryClient, id: string) => {
  queryClient.invalidateQueries({
    queryKey: savingsGoalsGetListQueryKey()
  });
  queryClient.invalidateQueries({
    predicate: query => query.queryKey.includes(id)
  });
};
